import { useEffect } from "react";
import { getAudio } from "@/audio";
import { humFlags } from "@/humSurprise";

const rand = (a, b) => a + Math.random() * (b - a);

const rumble = () => {
  if (humFlags.quiet) return;
  const { ctx, out } = getAudio();
  const t = ctx.currentTime, secs = 4.5;
  const buf = ctx.createBuffer(1, ctx.sampleRate * secs, ctx.sampleRate);
  const d = buf.getChannelData(0);
  let last = 0;
  for (let i = 0; i < d.length; i++) { last = last * 0.98 + (Math.random() * 2 - 1) * 0.02; d[i] = last * 6; }
  const src = ctx.createBufferSource();
  src.buffer = buf;
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 160;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(0.12, t + 0.6);
  g.gain.linearRampToValueAtTime(0.05, t + 1.6);
  g.gain.linearRampToValueAtTime(0.09, t + 2.2);
  g.gain.linearRampToValueAtTime(0.0001, t + secs);
  src.connect(lp).connect(g).connect(out);
  src.start(t);
};

export const useNightRainThunder = (on) => {
  useEffect(() => {
    if (!on) return;
    let timer;
    const thunder = () => {
      if (humFlags.quiet) return;
      rumble();
      window.__thunders = (window.__thunders || 0) + 1;
    };
    const schedule = () => { timer = setTimeout(() => { thunder(); schedule(); }, rand(45000, 120000)); };
    schedule();
    window.__thunderNow = thunder;
    return () => { clearTimeout(timer); delete window.__thunderNow; };
  }, [on]);
};
